import { render, staticRenderFns } from "./CategoryItemSiblings.vue?vue&type=template&id=0bdd3fc8"
import script from "./CategoryItemSiblings.vue?vue&type=script&lang=js"
export * from "./CategoryItemSiblings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports